export const CUSTOMER_PAGE_TAB_OPTIONS = Object.freeze({
  RealtimeActivity: 'realtime-activity',
  Invoices: 'invoices',
  Contract: 'contract',
  Settings: 'settings',
});

export type CustomerPageTabOption = typeof CUSTOMER_PAGE_TAB_OPTIONS[keyof typeof CUSTOMER_PAGE_TAB_OPTIONS];